export default function createDeckLayer(DeckProps, Layer, DeckLayerView2D) {
  return Layer.createSubclass({
    properties: {
      deck: {},
      blendMode: {},
      effect: {}
    },

    constructor() {
      this.deck = new DeckProps();
    },

    createLayerView(view) {
      if (view.type === '2d') {
        return new DeckLayerView2D({
          view,
          layer: this
        });
      }

      console.error('DeckLayer does not support SceneView at the moment. Use DeckRenderer instead.');
      return null;
    }

  });
}
//# sourceMappingURL=deck-layer.js.map